import React, { Component } from "react";
import styles from "./SimpleBtn.module.css";

function SimpleBtn({ children, className, link, target, onClick, style }) {
  return (
    <button
      className={`${styles.simpleBtn} ${className}`}
      onClick={onClick}
      style={style ? style : {}}>
      {link ? (
        <a
          className={`${styles.btnLink}`}
          href={link}
          target={target ? target : ""}
          rel="noopener noreferrer">
          {children}
        </a>
      ) : (
        children
      )}
    </button>
  );
}

export default SimpleBtn;
